<template>
  <div>
    <div>По типу заявок</div>
      <div id="chart_reg" style="width: 300px">
      <doughnut-chart  v-if="rendercomp" :chart-data="case_value" :options="case_option"></doughnut-chart>
        <div v-else> Нет данных </div>
    </div>
  </div>
</template>

<script>
import DoughnutChart from './DoughnutChart'
function getRandomColor () {
  var letters = '789ABC'
  var color = '#'
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 6)]
  }
  return color
}
export default {
  name: 'DoughnutRegion',
  props: {
    chartdata: {
      type: Array,
      default: null
    },
    chartlabels: {
      type: Array,
      default: null
    },
    capt: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      bgColors: [],
      rendercomp: true,
      case_value: {
        datasets: [
          {
            data: [],
            backgroundColor: [],
            label: []
          }],
        labels: []
      },
      case_option: {
        // Boolean - Whether we should show a stroke on each segment
        segmentShowStroke: true,
        // String - The colour of each segment stroke
        segmentStrokeColor: '#fff',
        // Number - The width of each segment stroke
        segmentStrokeWidth: 2,
        // Number - The percentage of the chart that we cut out of the middle
        percentageInnerCutout: 50, // This is 0 for Pie charts
        // Number - Amount of animation steps
        animationSteps: 100,
        // String - Animation easing effect
        animationEasing: 'easeOutBounce',
        // Boolean - Whether we animate the rotation of the Doughnut
        animateRotate: true,
        // Boolean - Whether we animate scaling the Doughnut from the centre
        animateScale: true,
        inGraphDataShow: true,
        inGraphDataTmpl: '<%=v2%>(<%=v6+"%"%>)',
        annotateDisplay: true,
        spaceBetweenBar: 5,
        graphTitleFontSize: 18,
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              let _percent = ((data['datasets'][0]['data'][tooltipItem['index']] / this.count_cases) * 100).toFixed(2)
              let _count = data['datasets'][0]['data'][tooltipItem['index']]
              return data['labels'][tooltipItem['index']] + ': ' + _count + ' (' + _percent + '%)'
            }
          }
        }// ,
        // String - A legend template
        // legendTemplate: '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<segments.length; i++){%><li><span style="background-color:<%=segments[i].fillColor%>"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>'
      }
    }
  },
  components: {
    DoughnutChart
  },
  created () {
    this.bgColors = Array(25).fill(getRandomColor()).map((x, y) => getRandomColor())
  },
  mounted () {
    this.fillData()
  },
  watch: {
    chartdata (newVal, oldVal) {
      this.case_value.datasets[0].data = newVal
      this.count_cases = this.chartdata.length ? this.chartdata.reduce((sum, cur) => { return sum + cur }) : 0
      this.forceRender()
    },
    chartlabels (newVal, oldVal) {
      this.case_value.labels = newVal
      this.case_value.datasets[0].label = newVal
      // this._chart.destroy()
      // this.renderChart(this.case_value, this.case_option)
    }
  },
  methods: {
    forceRender () {
      this.rendercomp = false
      this.$nextTick(() => {
        // Add the component back in
        this.rendercomp = true
      })
    },
    fillData () {
      // this.count_cases = this.chartdata.length ? this.chartdata.reduce((sum, cur) => { return sum + cur }) : 0
      this.case_value = {
        labels: this.chartlabels.slice(),
        datasets: [
          {
            data: this.chartdata.slice(),
            label: this.chartlabels.slice(),
            backgroundColor: this.bgColors.slice()
          }
        ]
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DoughnutCases.vue